import React from 'react';
import styles from '../AppointmentManagement/AppointmentManagement.module.css';
import {Appointment} from 'externalAPIs/insurance-eligibility';
import {CalendarIcon, CheckmarkIcon, CancelIcon, ExclamationIcon} from '../icons';
import {STATUS_TYPES} from '../utils';

interface AppointmentItemProps {
  appointment: Appointment;
  isUpcoming: boolean;
  status?: string;
  onCancelClick?: (appointment: Appointment) => void;
  isCanceling?: boolean;
}

const formatAppointmentDate = (dateString?: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  };
  return date.toLocaleString('en-US', options);
};

export const AppointmentItem: React.FC<AppointmentItemProps> = ({
  appointment,
  isUpcoming,
  status,
  onCancelClick,
  isCanceling,
}) => {
  const appointmentDate = appointment?.startTime ? formatAppointmentDate(appointment.startTime) : '';

  return (
    <div className={styles.appointmentItem}>
      <div className={styles.appointmentItemContent}>
        <div className={styles.appointmentItemLeft}>
          <div className={styles.appointmentProfilePicture}>
            {appointment.avatarUrl ? (
              <img src={appointment.avatarUrl} alt={appointment.providerName} />
            ) : (
              <div className={styles.profilePicturePlaceholder} />
            )}
          </div>
          <div className={styles.appointmentItemInfo}>
            <div className={styles.appointmentItemTitle}>Expert Chat</div>
            <div className={styles.appointmentItemDate}>
              <CalendarIcon />
              <span>{appointmentDate}</span>
            </div>
          </div>
        </div>
        {isUpcoming || status === STATUS_TYPES.CANCELLED ? (
          <div
            className={
              status === STATUS_TYPES.PENDING
                ? `${styles.statusBadge} ${styles.statusBadgePending}`
                : status === STATUS_TYPES.CANCELLED
                  ? `${styles.statusBadge} ${styles.statusBadgeCancelled}`
                  : styles.statusBadge
            }
          >
            {status === STATUS_TYPES.PENDING ? (
              <ExclamationIcon />
            ) : status === STATUS_TYPES.CANCELLED ? (
              <CancelIcon />
            ) : (
              <CheckmarkIcon />
            )}
            <span>{status ? status?.charAt(0).toUpperCase() + status?.slice(1) : ''}</span>
          </div>
        ) : null}
      </div>
      {isUpcoming && appointment.status !== 'Cancelled' && status !== STATUS_TYPES.CANCELLED ? (
        <div className={styles.appointmentItemActions}>
          <button
            className={styles.appointmentActionLink}
            type="button"
            onClick={() => onCancelClick?.(appointment)}
            disabled={isCanceling}
          >
            <CancelIcon />
            <span>Cancel session</span>
          </button>
        </div>
      ) : null}
    </div>
  );
};
